import { createFeatureSelector, createSelector } from "@ngrx/store";
import { selectRouteParam } from "src/app/router.selector";
import * as fromWorkspaces from "./workspaces.reducer";

export const selectWorkspacesState =
  createFeatureSelector<fromWorkspaces.WorkspacesState>(
    fromWorkspaces.workspacesFeatureKey,
  );

export const selectActiveWorkspace = createSelector(
  selectWorkspacesState,
  selectRouteParam("workspaceName"),
  (workspaceState, activeWorkspaceName) => {
    if (!workspaceState || !workspaceState.workspaces) return;

    return workspaceState.workspaces.find(
      (w) => w.name === activeWorkspaceName,
    );
  },
);
